export default __webpack_public_path__ + "static/media/course.e7592f94.svg";